import { ORGANIZATIONS } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import OrganizationPage from "./container/OrganizationPage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: ORGANIZATIONS,
    withSidebar: true,
    withAppBar: true,
    component: OrganizationPage,
  };
}
